<template>
  <div>
    <CollectionView :endpoint="playerId ? utilities.path('modules/punishments/players/@/bans', playerId) : utilities.path('modules/punishments/communities/@/bans', communityId)" v-model:reload="reload" default-order="createdAt:desc">
      <template v-slot:header>
        <div class="d-flex align-items-center justify-content-between">
          <h4 class="mb-0">{{ translate("bans") }}</h4>
          <ButtonView v-if="authorization.permission('modules.punishments.bans.create')" type="normal" color="primary" @click="creating = true">
            {{ translate("create") }}
          </ButtonView>
        </div>
      </template>
      <template v-slot:content="{ items }">
        <div class="card">
          <div class="table-responsive">
            <div class="table">
              <div class="table-header">
                <div v-if="!playerId" class="table-header-cell">{{ translate("target") }}</div>
                <div class="table-header-cell">{{ translate("reason") }}</div>
                <div class="table-header-cell">{{ translate("active") }}</div>
                <div class="table-header-cell">{{ translate("duration") }}</div>
                <div class="table-header-cell">{{ translate("createdAt") }}</div>
                <div class="table-header-cell">{{ translate("expiresAt") }}</div>
                <div class="table-header-cell">{{ translate("actions") }}</div>
              </div>
              <div class="table-body">
                <div class="table-row" v-for="item in items" :key="item.id">
                  <div v-if="!playerId" class="table-column">
                    <PlayerView :player="item.target"/>
                  </div>
                  <div class="table-column">
                    {{ item.reason }}
                  </div>
                  <div class="table-column">
                    <i v-if="!item.expiresAt || DateTime.fromISO(item.expiresAt).diff(DateTime.now()) > 0" class="fas fa-check text-success"></i>
                    <i v-else class="fas fa-xmark text-muted"></i>
                  </div>
                  <div class="table-column">
                    {{ item.duration ? utilities.formatDuration(item.duration, true) : translate("permanent") }}
                  </div>
                  <div class="table-column">
                    {{ utilities.formatDatetime(item.createdAt) }}
                  </div>
                  <div class="table-column">
                    {{ item.expiresAt ? utilities.formatDatetime(item.expiresAt) : translate("never") }}
                  </div>
                  <div class="table-column">
                    <div class="d-flex align-items-center g-2">
                      <ButtonView type="soft" color="primary" size="small" @click="viewingId = item.id">
                        <i class="fas fa-eye"></i>
                      </ButtonView>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </CollectionView>
    <ModalView v-model:active="creating">
      <template v-slot:body>
        <PlayerBanFormView :community-id="communityId" :player-id="playerId" @ban="creating = false; reload = true" @cancel="creating = false"/>
      </template>
    </ModalView>
    <ModalView :active="viewingId !== undefined" @update:active="viewingId = undefined">
      <template v-slot:body>
        <PlayerBanView :id="viewingId" @delete="viewingId = undefined; reload = true" @dismiss="viewingId = undefined"/>
      </template>
    </ModalView>
  </div>
</template>

<script setup>
import {CollectionView, ModalView, utilities, ButtonView} from "@/niftybit";
import PlayerView from "@/components/other/PlayerView.vue";
import {ref, watch} from "vue";
import PlayerBanFormView from "@/systems/modules/punishments/bans/PlayerBanFormView.vue";
import PlayerBanView from "@/systems/modules/punishments/bans/PlayerBanView.vue";
import authorization from "@/authorization";
import {DateTime} from "luxon";

const props = defineProps({
  communityId: String,
  playerId: String
});

const reload = ref(false);
const creating = ref(false);
const viewingId = ref(undefined);

watch(() => props.playerId, () => reload.value = true);

</script>

<style scoped>

</style>